import React from 'react';

export default function RubberDuck() {
	return (
		<g>
			<path fill="#FFEAAE" d="M115.00616,359.79486c0,15.13559-11.99403,25.25409-27.40541,27.4054
				c-50.94308,7.11133-57.04457-26.47464-57.46495-47.85425c-0.11552-5.87512,5.35025-10.36383,11.05526-8.95547
				c16.26221,4.01459,34.11201,1.9989,46.40968,1.9989C102.73634,332.38943,115.00616,344.65927,115.00616,359.79486z" />
			<circle fill="#FFEAAE" cx="84.66972" cy="329.22141" r="23.23638" />
			<path fill="#FFE094" d="M74.18383,354.63217c0,5.46689-4.40257,8.72278-9.89864,9.89865
				c-13.43827,2.87512-20.60411-9.56247-20.75595-17.28464c-0.04173-2.12204,2.13426-2.93829,3.99308-3.23465
				C47.52232,344.01154,74.18383,341.28516,74.18383,354.63217z" />
			<path fill="#FF8431" d="M101.94353,334.76239c-6.76274,1.17841-11.70834,3.1116-15.45768,2.52982
				c-0.16694,0.69669-0.00581,1.46689,0.5565,2.0354c2.2618,2.28601,6.45184,5.19696,11.78114,4.37485
				c3.48058-0.53696,8.28038-4.86716,8.60065-8.18665C107.42414,335.51581,108.70628,333.58401,101.94353,334.76239z" />
			<path fill="#FF9D5A" d="M107.26012,334.01218l-6.56575-2.80801c-1.18841-0.50824-2.53876-0.4758-3.70122,0.08868l-9.34268,4.53577
				c-0.49675,0.24112-0.85049,0.6369-1.04945,1.09244c-0.05218,0.11948-0.10122,0.27518-0.11517,0.37115
				c3.91158,1.43954,19.19784,1.90671,23.42075-0.81982C111.0969,335.70383,109.62919,334.88672,107.26012,334.01218z" />
			<path fill="#515151" d="M87.87776,325.92957c-1.25005,0-2.26762,1.15381-2.26762,2.57202
				c0,1.41873,1.01756,2.57254,2.26762,2.57254c1.25113,0,2.26869-1.15381,2.26869-2.57254
				C90.14645,327.08337,89.12889,325.92957,87.87776,325.92957z" />
			<path fill="#515151" d="M103.65696,324.63031c-1.25114,0-2.26869,1.15381-2.26869,2.57254
				c0,1.41821,1.01756,2.57202,2.26869,2.57202c1.25005,0,2.26761-1.15381,2.26761-2.57202
				C105.92457,325.78412,104.90701,324.63031,103.65696,324.63031z" />
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Toy/RubberDuck.js